export default __webpack_public_path__ + "assets/02708ac4db91429d33be2eac66b2981b.svg";